const dataMutiId = [
  {
    id: 7,
    url: 'ims-00241',
    image: require('../../../../../assets/iso/IMS-00241.jpg'),
    title: 'SUCOFINDO INTERNASIONAL SERTIFIKAT SERVIS',
    description: 'PT. REMALA ABADI Tbk - Telah menerapkan sistem manajemen terintegrasi',
    scope:
      'Jasa Penyediaan Layanan Internet yang mencakup layanan internet Broadband (Internet Service Provider/ISP), Layanan Local Link, Layanan Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, serta Penyediaan Konektivitas/Instalasi Fiber Optic Business to Business',
  },
  {
    id: 4,
    url: 'iso-9001',
    image: require('../../../../../assets/iso/QSC-02073.jpg'),
    title: 'SNI ISO 9001 : 2015',
    description: 'Sistem Manajemen Mutu - Persyaratan.',
    scope:
      'Pengendalian Aspek dan Dampak Lingkungan pada Jasa Penyediaan Layanan Internet yang mencakup layanan internet Broadband (Internet Service Provider/ISP) Layanan Local Link, Layanan Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, serta Penyediaan Konektivitas/Instalasi Fiber Optic Bisnis ke Bisnis',
  },
  {
    id: 5,
    url: 'iso-37001',
    image: require('../../../../../assets/iso/SAB-00147.jpg'),
    title: 'SNI ISO 37001 : 2016',
    description: 'Sistem Manajemen Anti Penyuapan.',
    scope: 'Penerapan sistem manajemen anti penyuapan pada Divisi HRGA & Legal, Purchasing, Finance Accounting Tax',
  },
  {
    id: 2,
    url: 'iso-27001',
    image: require('../../../../../assets/iso/ISMS-00025.jpg'),
    title: 'SNI ISO/IEC 27001 : 2022',
    description: 'Persyaratan Sistem Manajemen Keamanan Informasi.',
    scope:
      'Pengendalian Aspek dan Dampak Lingkungan pada Jasa Penyediaan Layanan Internet yang mencakup layanan internet Broadband (Internet Service Provider/ISP) Layanan Local Link, Layanan Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, serta Penyediaan Konektivitas/Instalasi Fiber Optic Bisnis ke Bisnis',
  },
  {
    id: 3,
    url: 'iso-45001',
    image: require('../../../../../assets/iso/OHS-00252.jpg'),
    title: 'SNI ISO 45001 : 2018',
    description: 'Sistem Manajemen Kesehatan dan Keselamatan Kerja - Persyaratan dengan panduan penggunaan.',
    scope:
      'Pengendalian Aspek dan Dampak Lingkungan pada Jasa Penyediaan Layanan Internet yang mencakup layanan internet Broadband (Internet Service Provider/ISP) Layanan Local Link, Layanan Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, serta Penyediaan Konektivitas/Instalasi Fiber Optic Bisnis ke Bisnis',
  },
  {
    id: 1,
    url: 'iso-14001',
    image: require('../../../../../assets/iso/EMS-00452.jpg'),
    title: 'SNI ISO 14001 : 2015',
    description: 'Sistem Manajemen Lingkungan - Persyaratan dengan panduan penggunaan.',
    scope:
      'Pengendalian Aspek dan Dampak Lingkungan pada Jasa Penyediaan Layanan Internet yang mencakup layanan internet Broadband (Internet Service Provider/ISP) Layanan Local Link, Layanan Managed Services (setting IP CAM, VOIP, WiFi Device), Server Collocation, serta Penyediaan Konektivitas/Instalasi Fiber Optic Bisnis ke Bisnis',
  },
  {
    id: 6,
    url: 'iso-20000-1',
    image: require('../../../../../assets/iso/ISO20000-1-ACS-2026.jpeg'),
    title: 'SNI ISO 20000-1 : 2018',
    description: 'Penyedia Layanan Internet untuk Internet Dedikasi.',
    scope: 'Penyedia Layanan Internet yang Melayani Internet Dedikasi, Internet Broadband, dan Layanan Manajemen untuk Perangkat Wi-Fi, LAN, Perangkat Lunak Aplikasi, dan Manajemen Layanan TI',
  },
];

export default dataMutiId;
